<template>
	<div>
		<v-card flat v-if="loading">
			<v-card-text class="text-xs-center pa-5">
				<v-progress-circular indeterminate color="yellow darken-3"></v-progress-circular>
				<p class="mt-3">Loading AI File Meta...</p>
			</v-card-text>
		</v-card>
		<v-card flat v-else-if="error">
			<v-card-text class="text-xs-center pa-5">
				<v-icon color="red" large>error</v-icon>
				<p class="mt-3 red--text">{{ error }}</p>
			</v-card-text>
		</v-card>
		<v-card flat v-else>
			<v-card-text>
				<brace
					style="height:90vh;"
					class="kbet-editor"
					:mode="'json'"
					:readonly="true"
					@setHandler="
						h => {
							editorHandler = h;
						}
					"
				/>
			</v-card-text>
		</v-card>
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
export default {
	components: {},
	data() {
		return {
			editorHandler: false,
			loading: true,
			error: null,
			fileMeta: null,
		};
	},
	created() {
		this.fetchFileMeta();
	},
	methods: {
		...mapActions('aiMetaMap', ['getFileMeta']),
		fetchFileMeta() {
			this.loading = true;
			this.error = null;
			this.getFileMeta({
				_id: this.selectedFile.aiMetaUsed,
			}).then(data => {
				this.loading = false;
				if (data && data.ok) {
					this.fileMeta = data.meta;
					if (this.editorHandler) {
						this.editorHandler.setValue(JSON.stringify(data.meta, null, 2));
					}
				} else {
					this.error = data.msg || 'Failed to load AI file meta';
				}
			}).catch(err => {
				this.loading = false;
				this.error = err.toString() || 'Failed to load AI file meta';
			});
		},
	},
	computed: {
		...mapGetters('aiMetaMap', ['selectedFile']),
	},
	watch: {
		editorHandler(val) {
			if (val && this.fileMeta) {
				val.setValue(JSON.stringify(this.fileMeta, null, 2));
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.v-card__text {
	padding: 0px;
}
</style>
